module.exports = __webpack_public_path__ + "static/img/212.7bae5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/212.png
// module id = LEcS
// module chunks = 1